import React from "react";

import "./badge.scss";

const StatusBadge = ({
  size = "md",
  status = "primary",
  children,
  fullWidth = false,
  className = "",
  ...others
}) => {
  const badgeClasses = `badge badge-${status} ${className}`;
  const dataBlockProps = fullWidth ? { "data-block": true } : {};

  return (
    <div
      className={badgeClasses}
      data-size={size}
      {...dataBlockProps}
      {...others}
    >
      <span className="badge__label">{children}</span>
    </div>
  );
};

export default StatusBadge;
